import { Radio } from 'antd'
import type { RadioGroupProps } from 'antd/lib/radio'
import styled from 'styled-components'

type FormRadioGroupProps = RadioGroupProps & { direction?: 'column' | 'row' }
const FormRadioGroup = (props: FormRadioGroupProps) => (
  <StyledRadioGroup $direction={props.direction} {...props} />
)

const StyledRadioGroup = styled(Radio.Group)<{
  $direction?: 'column' | 'row'
}>`
  display: flex;
  align-items: flex-start;
  flex-direction: ${(props) => props.$direction || 'column'};
`

export default FormRadioGroup
